import React from "react";
import { LuLoaderCircle } from "react-icons/lu";

const variantClasses = {
  main: "tw-border-dis-sky tw-bg-dis-sky tw-text-dis-navy hover:tw-border-dis-sky-hover hover:tw-bg-dis-sky-hover",
  dark: "tw-border-dis-navy tw-bg-dis-navy tw-text-white hover:tw-border-dis-deep-blue hover:tw-bg-dis-deep-blue",
  soft: "tw-border-dis-field tw-bg-dis-field tw-text-dis-navy hover:tw-border-dis-field-hover hover:tw-bg-dis-field-hover",
  softQuote: "tw-border-dis-field tw-bg-dis-field tw-text-dis-deep-blue hover:tw-border-dis-field-hover hover:tw-bg-dis-field-hover",
  outline: "tw-border-dis-deep-blue tw-bg-white tw-text-dis-navy hover:tw-bg-dis-sky-tint",
  home: "tw-border-white tw-bg-white tw-text-dis-navy hover:tw-border-dis-sky-tint hover:tw-bg-dis-sky-tint",
  back: "tw-bg-dis-field-hover tw-text-dis-navy hover:tw-bg-dis-sky-tint",
  disabled: "tw-border-dis-disabled tw-bg-dis-disabled tw-text-white",
};

const sizeClasses = {
  small: "tw-min-h-11 tw-px-5 tw-text-base",
  card: "tw-min-h-12 tw-px-5 tw-text-base",
  default: "tw-min-h-[52px] tw-px-5 tw-text-base",
  large: "tw-min-h-14 tw-px-[22px] tw-text-lg",
  hero: "tw-min-h-[60px] tw-px-[30px] tw-text-xl",
  circle: "tw-h-[52px] tw-min-h-[52px] tw-w-[52px] tw-min-w-[52px] tw-p-0 tw-text-base",
};

const Button = React.forwardRef(
  (
    {
      variant = "main",
      size = "default",
      fullWidth = false,
      loading = false,
      loadingText,
      disabled = false,
      leadingIcon,
      trailingIcon,
      className = "",
      type = "button",
      children,
      ...props
    },
    ref,
  ) => {
    const isDisabled = disabled || loading;
    const isDisabledVariant = variant === "disabled" || isDisabled;
    const hasDisabledStyle = isDisabledVariant && variant !== "back";
    const label = loading && loadingText ? loadingText : children;

    return (
      <button
        {...props}
        ref={ref}
        type={type}
        disabled={isDisabled}
        aria-busy={loading || undefined}
        className={`tw-inline-flex tw-box-border tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2.5 tw-whitespace-nowrap tw-rounded-dis-pill tw-border-solid ${variant === "back" ? "tw-border-0" : "tw-border-2"} tw-font-bold tw-leading-[1.2] tw-transition-colors focus-visible:tw-outline-[3px] focus-visible:tw-outline-dis-navy focus-visible:tw-outline-offset-2 focus-visible:tw-shadow-dis-focus motion-reduce:tw-transition-none disabled:tw-cursor-not-allowed ${sizeClasses[size] || sizeClasses.default} ${size === "circle" ? "tw-w-[52px]" : fullWidth ? "tw-w-full" : "tw-w-max"} ${hasDisabledStyle ? "tw-border-dis-disabled tw-bg-dis-disabled tw-text-white hover:tw-border-dis-disabled hover:tw-bg-dis-disabled" : variantClasses[variant] || variantClasses.main} ${isDisabled && !hasDisabledStyle ? "disabled:tw-opacity-60" : ""} ${className}`}
      >
        {loading ? (
          <LuLoaderCircle
            className="tw-h-5 tw-w-5 tw-shrink-0 tw-animate-spin"
            aria-hidden="true"
          />
        ) : (
          leadingIcon
        )}
        {label}
        {!loading && trailingIcon}
      </button>
    );
  },
);

Button.displayName = "Button";

export default Button;
